import React from "react";
import PropTypes from "prop-types";
import Fuzzy from "./Fuzzy";

class Search extends React.Component {
    render() {
        return (
            <section className="search" role="search">
                <div className="wrapper">
                    <h3 className="search__legend">Search</h3>
                    <Fuzzy {...this.props} />
                </div>
            </section>
        );
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js